
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        kecamatan: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        tgl1: null,
        tgl2: null,
        nama: "",
        tempat1: "",
        tempat2: "",
        jenis: "",
        deskripsi: "",
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    // subTotalCols() {
    //   const cols = this.indikatorSchema.table.sumColumns;
    //   const rows = this.normalizedCetakRows;

    //   const totals = {};

    //   cols.forEach((c) => (totals[c] = 0));

    //   rows.forEach((r) => {
    //     cols.forEach((c) => {
    //       totals[c] += Number(r[c] || 0);
    //     });
    //   });

    //   return totals;
    // },

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      // 👉 Hitung percentage dari total A dan total B
      let percentage = 0;

      const id = this.form?.indikator?.id;

      if (id == 6) {
        percentage =
          totals.total > 0 ? ((totals.a / totals.total) * 100).toFixed(2) : 0;
      } else if (id == 10 || id == 12) {
        percentage =
          totals.a > 0
            ? ((totals.b / totals.a) * 100).toFixed(2)
            : 0;
      } else {
        percentage =
          totals.b > 0 ? ((totals.a / totals.b) * 100).toFixed(2) : 0;
      }

      totals.percentage = percentage;

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah akta kelahiran yang diterbitkan" },
                { label: "Jumlah keseluruhan anak usia 0 - 17" },
                { label: "Persentase kepemilikan akta kelahiran", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah akta kelahiran yang diterbitkan",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah keseluruhan anak usia 0 - 17",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Nama Lengkap" },
                { label: "Jenis Kelamin" },
                { label: "Tempat dan Tangal Lahir" },
                { label: "Nomor Akta Kelahiran", width: "8%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "jenis", "tempat_tanggal", "deskripsi"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap",
                    type: "text",
                  },
                  {
                    label: "Jenis Kelamin",
                    key: "jenis",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: "Laki-Laki" },
                      { label: "Perempuan", value: "Perempuan" }
                    ]
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "tempat1",
                    label: "Tempat Lahir",
                    type: "text",
                  },
                  {
                    label: "Tanggal Lahir",
                    key: "tgl1",
                    type: "date",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "deskripsi",
                    label: "Nomor Akta Kelahiran",
                    type: "text",
                  }
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl = row.tgl1
              ? new Date(row.tgl1).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tempat_tanggal: `${row.tempat1 || ""}${
                row.tempat1 && tgl ? ", " : ""
              }${tgl}`,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 3
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Kepemilikan KIA" },
                { label: "Jumlah Sasaran Kepemilikan KIA" },
                { label: "Total Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Kepemilikan KIA",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Sasaran Kepemilikan KIA",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 4
      // =========================
      if (id === 4) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Nama Anak" },
                { label: "Jenis Kelamin" },
                { label: "Tempat dan Tangal Lahir" },
                { label: "Nomor KIA (NIK)" },
                { label: "Keterangan", width: "12%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "jenis", "tempat_tanggal", "deskripsi"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Anak",
                    type: "text",
                  },
                  {
                    label: "Jenis Kelamin",
                    key: "jenis",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: "Laki-Laki" },
                      { label: "Perempuan", value: "Perempuan" }
                    ]
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "tempat1",
                    label: "Tempat Lahir",
                    type: "text",
                  },
                  {
                    label: "Tanggal Lahir",
                    key: "tgl1",
                    type: "date",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "deskripsi",
                    label: "Nomor KIA (NIK)",
                    type: "text",
                  }
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl = row.tgl1
              ? new Date(row.tgl1).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tempat_tanggal: `${row.tempat1 || ""}${
                row.tempat1 && tgl ? ", " : ""
              }${tgl}`,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Uraian Dokumen", rowspan: 2, width: "12%" },
                { label: "Jumlah Penyajian Data Kependudukan", colspan: 2 },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Semester 1 (Tanggal Rilis)" },
                { label: "Semester 2 (Tanggal Rilis)" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "tgl1", "tgl2"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Uraian Dokumen",
                    type: "text",
                  }
                ],
              },
              {
                title: "Jumlah Penyajian Data Kependudukan",
                cols: 2,
                fields: [
                  {
                    key: "tgl1",
                    label:
                      "Semester 1 (Tanggal Rilis)",
                    type: "date",
                  },
                  {
                    key: "tgl2",
                    label: "Semester 2 (Tanggal Rilis)",
                    type: "date",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl1 = row.tgl1
              ? new Date(row.tgl1).toLocaleDateString("id-ID")
              : "";
            const tgl2 = row.tgl2
              ? new Date(row.tgl2).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tgl1,
              tgl2,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 6
      // =========================
      if (id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Penduduk Yang Berumut 17 Tahun Ke Atas" },
                { label: "Memiliki KTP Elektronik" },
                { label: "Belum Memiliki KTP Elektronik" },
                { label: "Persentase Kepemilikan (%)", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["total", "a", "b", "percentage"],
            sumColumns: ["total","a", "b"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 2,
                fields: [
                  { key: "a", label: "Memiliki KTP Elektronik", type: "number" },
                  { key: "b", label: "Belum Memiliki KTP Elektronik", type: "number" },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
              percentage: a + b > 0 ? ((a / (a + b)) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 7
      // =========================
      if (id === 7) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Penduduk" },
                { label: "Laki-Laki (17 Tahun Ke Atas)" },
                { label: "Perempuan (17 Tahun Ke Atas)" },
                { label: "Wajib Memiliki KTP" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a","b", "c","total"],
            sumColumns: ["a", "b", "c", "total"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 3,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Penduduk",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Laki-Laki (17 Tahun Ke Atas)",
                    type: "number",
                  },
                  {
                    key: "c",
                    label: "Perempuan (17 Tahun Ke Atas)",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);

            return {
              ...row,
              a,
              b,
              c,
              total: b + c,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 8
      // =========================
      if (id === 8) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Jumlah Penerbitan Akta Kematian", width: "12%" },
                { label: "Jumlah Penduduk Yang Tercatat Dalam Register Kematian" },
                { label: "Total Capaian (%)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label:
                      "Jumlah Penerbitan Akta Kematian",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Penduduk Yang Tercatat Dalam Register Kematian",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 9
      // =========================
      if (id === 9) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Nama Lengkap Jenazah" },
                { label: "Jenis Kelamin" },
                { label: "Tempat dan Tangal Lahir" },
                { label: "Tempat dan Tangal Kematian" },
                { label: "Nomor Akta Kematian (diterbitkan)", width: "8%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "jenis", "tempat_lahir", "tempat_kematian", "deskripsi"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap Jenazah",
                    type: "text",
                  },
                  {
                    label: "Jenis Kelamin",
                    key: "jenis",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: "Laki-Laki" },
                      { label: "Perempuan", value: "Perempuan" }
                    ]
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "tempat1",
                    label: "Tempat Lahir",
                    type: "text",
                  },
                  {
                    label: "Tanggal Lahir",
                    key: "tgl1",
                    type: "date",
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "tempat2",
                    label: "Tempat Kematian",
                    type: "text",
                  },
                  {
                    label: "Tanggal Kematian",
                    key: "tgl2",
                    type: "date",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "deskripsi",
                    label: "Nomor Akta Kematian (diterbitkan)",
                    type: "text",
                  }
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl1 = row.tgl1
              ? new Date(row.tgl1).toLocaleDateString("id-ID")
              : "";
            const tgl2 = row.tgl2
              ? new Date(row.tgl2).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tempat_lahir: `${row.tempat1 || ""}${
                row.tempat1 && tgl1 ? ", " : ""
              }${tgl1}`,
              tempat_kematian: `${row.tempat2 || ""}${
                row.tempat2 && tgl2 ? ", " : ""
              }${tgl2}`,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 10
      // =========================
      if (id === 10) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Jumlah Akta Perkawinan Diterbitkan", colspan: 2 },
                { label: "Jumlah Buku Nikah", colspan: 2 },
                { label: "Total Capaian (%)", rowspan: 2, width: "15%" },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Akta Yang Teregister" },
                { label: "Akta Yang Diterbitkan" },
                { label: "Dilaporkan" },
                { label: "Diterbitkan" },
              ],
            ],

            bodyColumns: ["a","b","c","d","percentage",],
            sumColumns: ["a","b","c","d"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Akta Perkawinan Diterbitkan",
                cols: 2,
                fields: [
                  { key: "a", label: "Akta Yang Teregister", type: "number" },
                  { key: "b", label: "Akta Yang Diterbitkan", type: "number" },
                ],
              },
              {
                title: "Jumlah Buku Nikah",
                cols: 2,
                fields: [
                  { key: "c", label: "Dilaporkan", type: "number" },
                  { key: "d", label: "Diterbitkan", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              percentage: (a  > 0
                ? (b / a) * 100
                : 0
              ).toFixed(2)
            };
          },
        };
      }

      // =========================
      // INDIKATOR 11
      // =========================
      if (id === 11) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Nama Lengkap Pasangan" },
                { label: "Tempat dan Tanggal Perkawinan" },
                { label: "Nomor Akta Perkawinan / Nomor Buku Nikah" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "tempat_tanggal", "deskripsi"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap Pasangan",
                    type: "text",
                  }
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "tempat1",
                    label: "Tempat Perkawinan",
                    type: "text",
                  },
                  {
                    label: "Tanggal Perkawinan",
                    key: "tgl1",
                    type: "date",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "deskripsi",
                    label: "Nomor Akta Perkawinan / Nomor Buku Nikah",
                    type: "text",
                  }
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl = row.tgl1
              ? new Date(row.tgl1).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tempat_tanggal: `${row.tempat1 || ""}${
                row.tempat1 && tgl ? ", " : ""
              }${tgl}`,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 12
      // =========================
      if (id === 12) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Jumlah Akta Perceraian Diterbitkan", colspan: 2 },
                { label: "Jumlah Pelaporan Perceraian", colspan: 2 },
                { label: "Total Capaian (%)", rowspan: 2, width: "15%" },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Akta Yang Teregister" },
                { label: "Akta Yang Diterbitkan" },
                { label: "Dilaporkan" },
                { label: "Diterbitkan" },
              ],
            ],

            bodyColumns: ["a","b","c","d","percentage",],
            sumColumns: ["a","b","c","d"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Akta Perceraian Diterbitkan",
                cols: 2,
                fields: [
                  { key: "a", label: "Akta Yang Teregister", type: "number" },
                  { key: "b", label: "Akta Yang Diterbitkan", type: "number" },
                ],
              },
              {
                title: "Jumlah Pelaporan Perceraian",
                cols: 2,
                fields: [
                  { key: "c", label: "Dilaporkan", type: "number" },
                  { key: "d", label: "Diterbitkan", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              percentage: (a > 0
                ? (b / a * 100)
                : 0
              ).toFixed(2)
            };
          },
        };
      }

      // =========================
      // INDIKATOR 13
      // =========================
      if (id === 13) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan", width: "12%" },
                { label: "Nama Lengkap Pasangan" },
                { label: "Tanggal dan Tempat Perceraian" },
                { label: "Nomor Akta Perceraian" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "tempat_tanggal", "deskripsi"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap Pasangan",
                    type: "text",
                  }
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "tempat1",
                    label: "Tempat Perceraian",
                    type: "text",
                  },
                  {
                    label: "Tanggal Perceraian",
                    key: "tgl1",
                    type: "date",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "deskripsi",
                    label: "Nomor Akta Perceraian",
                    type: "text",
                  }
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl = row.tgl1
              ? new Date(row.tgl1).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tempat_tanggal: `${row.tempat1 || ""}${
                row.tempat1 && tgl ? ", " : ""
              }${tgl}`,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 14
      // =========================
      if (id === 14) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Jumlah Penduduk", colspan: 3 },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Laki-Laki" },
                { label: "Perempuan" },
                { label: "Jumlah" },
              ],
            ],

            bodyColumns: ["a","b"],
            sumColumns: ["a","b"],
            showTotal: true,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Penduduk",
                cols: 2,
                fields: [
                  { key: "a", label: "Laki-Laki", type: "number" },
                  { key: "b", label: "Perempuan", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DISDUKCAPIL + "viewCapil", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "DISDUKCAPILCapil", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DISDUKCAPIL + "indikator", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Kependudukan & Pencatatan Sipil</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DISDUKCAPIL + "addCapil", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DISDUKCAPIL + "editCapil", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DISDUKCAPIL + "removeCapil", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.nama = data.nama;
      this.form.jenis = data.jenis;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.tempat1 = data.tempat1;
      this.form.tempat2 = data.tempat2;
      this.form.tgl1 = data.tgl1;
      this.form.tgl2 = data.tgl2;
      this.form.deskripsi = data.deskripsi;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
